import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppProviders } from './providers/app-providers';
import { App } from './App';
import './app/styles/globals.css';
import { applyFontSize, getStoredFontSize } from '@shared/hooks/use-font-size';

// Initialize stored font size preference before first render
applyFontSize(getStoredFontSize());

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <AppProviders>
        <App />
      </AppProviders>
    </BrowserRouter>
  </StrictMode>,
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((reg) => console.log('Firebase Service Worker registered', reg))
      .catch((err) => console.error('Service Worker registration failed', err));
  });
}
